export default __webpack_public_path__ + "static/media/spr-background-volcanism.78c28bca.jpg";